<form [formGroup]="form" fxLayout="column" fxLayoutGap="10px">
  <label class="dashboard-image-upload__form-label">{{ label }}</label>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
    <input
      class="dashboard-image-upload__form-file-input"
      #fileInput
      type="file"
      (change)="handleFileInput($event)"
      [accept]="supportedImageExtensions"
    />
    <button
      *ngrxLet="uploadCompleted$ as uploadCompleted"
      mat-button
      color="primary"
      type="button"
      fxFlexAlign="start"
      (click)="uploadCompleted || tempImageUrl || isImageToEdit ? resetImage() : fileInput.click()"
    >
      {{ uploadCompleted || tempImageUrl || isImageToEdit ? ('Reset image' | uppercase) : ('Select image' | uppercase) }}
    </button>
    <mat-progress-bar
      *ngIf="uploadIsInProgress$ | async"
      color="accent"
      mode="determinate"
      [value]="uploadProgress$ | async"
    ></mat-progress-bar>
    <img
      class="dashboard-image-upload__form-image-preview"
      [ngClass]="
        size === IMAGE_SIZES.SMALL
          ? 'dashboard-image-upload__form-image-preview--small'
          : size === IMAGE_SIZES.MEDIUM
          ? 'dashboard-image-upload__form-image-preview--medium'
          : 'dashboard-image-upload__form-image-preview--big'
      "
      *ngIf="tempImageUrl || isImageToEdit || (uploadCompleted$ | async)"
      [src]="isImageToEdit ? publicUrl + imgPath : safeImageUrl ? safeImageUrl : publicUrl + (uploadedFiles ? uploadedFiles[0] : '')"
      [alt]="imageFile?.name"
    />
  </div>
</form>
